<template>
  <div id="app">
    <quartier
      v-if="okanMain.selectedBatiment == null"
      v-bind:okanMain="okanMain"
      v-bind:params="okanMain.params"
      ref="quartier"
    />


    <div v-show="!okanMain.showAppartDetails && okanMain.selectedBatiment != null">
      <div id="UIDiv">
            <button 
                id="btnBack" 
                @click="goBack"
                class="goToBat"
                v-show="okanMain.jsonData != null && okanMain.jsonData.AppartsCoords.length > 1"
            ></button>        
        <div class="help" @click="showHelp = !showHelp"></div>
        <div class="helpDiv" v-show="showHelp">
          <span class="rightSpan1">Molette pour zoomer</span>
          <br />
          <span class="rightSpan2">Clic gauche maintenu pour déplacer</span>
          <span id="leftSpan">Clic sur menu pour voir les options</span>
          <span v-show="okanMain.jsonData != null && okanMain.jsonData.AppartsCoords.length > 1" id="goBackHelp">Retour au programme complet</span>

          <div id="directionalButtonsDiv">
            <div class="mainButtonContainer" id="prevImageContainer">
              <button id="prevImage" class="mainButton" @click="changeImage(true)"></button>
            </div>
            <div class="mainButtonContainer" id="moveCanvasContainer">
              <button
                id="moveCanvas"
                class="mainButton"
                @click="toggleMoveCanvas"
                v-bind:class="{'active' : okanMain.allowMoveCanvas}"
              ></button>
            </div>
            <div class="mainButtonContainer" id="nextImageContainer">
              <button id="nextImage" class="mainButton" @click="changeImage(false)"></button>
            </div>
            <div class="mainButtonContainer" id="zoomInContainer">
              <button id="zoomIn" class="mainButton" @click="changeZoom(true)"></button>
            </div>
            <div class="mainButtonContainer" id="zoomOutContainer">
              <button id="zoomOut" class="mainButton" @click="changeZoom(false)"></button>
            </div>
            <div class="mainButtonContainer" id="autoRotateContainer">
              <button
                id="autoRotate"
                class="mainButton togglable"
                @click="toggleAutorotate"
                v-bind:class="{'active' : okanMain.autoRotate}"
              ></button>
            </div>
          </div>
        </div>
        <div 
          id="menuButtonDiv"
          v-bind:class="{'expanded' : menuExpanded }"
          @click="menuExpanded=!menuExpanded"
         
        >
          <div id="menuPicto"></div>
        </div>

        <div
          v-show="!okanMain.showAppartDetails"
          id="menuDiv"
          v-bind:class="{'expanded' : menuExpanded }"
        >
          <div id="etages">
            <div id="etagesTitle">Étages</div>
          </div>
          <div id="stagesContainer">
            <div
              class="stage"
              v-for="(stair) in okanMain.stairsData"
              v-bind:key="stair.id"
              v-bind:value="stair.id"
              v-bind:class="{'selectedStage' : stair.id == okanMain.currentStair}"
              @click="changingStair(stair.id)"
            >
              <span @click="changingStair(stair.id)">{{stair.name}}</span>
              <div v-if="stair.id != 0" class="stagesSeparator"></div>
            </div>
          </div>
          <div id="nbPieces" v-show="okanMain.currentStair != null && okanMain.sliderData.max > okanMain.sliderData.min">
            <div id="nbPiecesTitle">Nombre de pièces</div>
            <div id="sliderContainer" v-show="okanMain.currentStair != null">
              <vue-slider
                @change="updateFilters"
                v-model="okanMain.sliderData.value"
                v-if="okanMain.sliderData != null"
                :marks="true"
                :disabled="okanMain.currentStair == null"
                :min="okanMain.sliderData.min"
                :max="okanMain.sliderData.max"
                :tooltip-formatter="val => val + makeToolTip(val)"
              ></vue-slider>
            </div>            
          </div>

          <div id="visitesVirtuelles" v-show="false">
            <div id="visitesVirtuellesTitle">{{okanMain.labelVisite}}</div>
            <div id="stagesContainer">
              <div class="virtualTour stage"
                v-for="(type, typeIndex) in okanMain.flatsData"
                v-bind:key="typeIndex"
                @click="okanMain.shortcutLink(type.id)"
                v-show="type.id > 1 && type.id < 5"
              ><!-- attention le v-show est spécifique car pas de visite virtuelle T1 sur ce pack--> 
                  <span>{{type.name}}</span>
                  <div class="stagesSeparator"></div>
              </div>
            </div>
          </div>


        </div>
      </div>

      <div id="containerDiv">
        <div id="compassContainer" v-show="okanMain != null && okanMain.params != null && okanMain.params.boussole">
          <div id="north"></div>
          <div id="compass"></div>
        </div>
        <div id="drawingDiv">
          <div id="backgroundDiv">
          </div>
          <canvas id="batCanvas"></canvas>
          <canvas id="textCanvas"></canvas>
        </div>

        <div id="batNameOverlay"
          v-if="okanMain.selectedAppart!= null && !okanMain.showAppartDetails && okanMain.jsonData.AppartsCoords.length > 1"
        >
          <div class="text">{{getbatName()}}</div>
        </div>       
      </div>
    </div>

    <ariane v-bind:okanMain="okanMain" />

    <popup
      v-bind:okanMain="okanMain"
      v-bind:appartData="okanMain.selectedAppart"
      v-if="okanMain.selectedAppart!= null && !okanMain.showAppartDetails"
    />

    <appartDetails
      v-if="okanMain.showAppartDetails"
      v-bind:appartData="okanMain.selectedAppart"
      v-bind:okanMain="okanMain"
      v-bind:params="okanMain.params"
      ref="appartDetails"
    />

    <div id="mentionsLegout" v-show="!showHelp && !okanMain.showAppartDetails">
      <span ><i>* Visuels non contractuels, illustrations à caractère d'ambiance.</i></span><br/>
      <span class="rightAlign"><i>  Réalisation <a href="http://www.okan3d.com" target="_blank">Okénite Animation</a></i></span>
    </div>
  </div>
</template>

<script>
import okanMain from "./okanMain.js";
import appartDetails from "./components/details";
import popup from "./components/popup";
import ariane from "./components/Ariane";
import quartier from "./components/quartier";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  name: "App",
  components: {
    appartDetails,
    popup,
    ariane,
    VueSlider,
    quartier
  },
  data: function() {
    return {
      okanMain: new okanMain(),
      level: null,
      typeFilter: null,
      selectedStair: null,
      showingDetails: false,
      showHelp: false,
      menuHovered: false,
      menuContentHovered: false,
      menuExpanded: true,
    };
  },
  mounted() {
    this.okanMain.setData();
    this.okanMain.log("mounted")
    //this.makeSlider();
    //this.okanMain.init(flats_data);
  },
  methods: {
    getbatName(){
      if(this.okanMain.params.batiments[this.okanMain.hoveredBatiment].title != "")
        return this.okanMain.params.batiments[this.okanMain.hoveredBatiment].title;
      var _array = this.okanMain.jsonData.AppartsCoords[this.okanMain.hoveredBatiment].appartsAtFrame;
      var found = false;
      var i = 0;
      while (!found && i < _array.length){
        if(_array[i]!=null && _array[i]!=undefined){
          if(_array[i].apparts.length > 0 && _array[i].apparts[0].batName != undefined){
            found = true;
            return  "Bâtiment" + _array[i].apparts[0].batName;
          }
        }
        i++;
      }
      return "";
    },    
    setHover(menuButton, value, delay=1){
      if(menuButton)
        this.menuHovered=value;
      else
        this.menuContentHovered = value;
      setTimeout(() => {
        this.menuExpanded = this.menuHovered || this.menuContentHovered;
      }, delay);
    },
    changingStair(id) {
      var oldPos = this.okanMain.stairsData.find(
        x => x.id == this.okanMain.currentStair
      ).pos;
      var newPos = this.okanMain.stairsData.find(x => x.id == id).pos;
      this.okanMain.currentStair = id;
      this.okanMain.imageChange(
        this.okanMain.currentFrame +
          (newPos - oldPos) * this.okanMain.imagesPerLevel
      );
    },
    updateFilters() {
      this.okanMain.flatsData.forEach(element => {
        element.check =
          element.id >= this.okanMain.sliderData.value[0] &&
          element.id <= this.okanMain.sliderData.value[1];
      });

      this.okanMain.getStairData(this.okanMain.currentFrame);
    },
    toggleAutorotate() {
      this.okanMain.autoRotate = !this.okanMain.autoRotate;
      this.okanMain.setAutoRotate();
    },
    toggleMoveCanvas() {
      this.okanMain.allowMoveCanvas = !this.okanMain.allowMoveCanvas;
    },
    changeImage(next) {
      this.okanMain.autoRotate = false;
      var sens;
      if (next) sens = 1;
      else sens = -1;
      this.okanMain.changeImage(sens);
    },
    changeZoom(zoomIn) {
      var event = {
        deltaY: 0
      };
      if (zoomIn) event.deltaY = -1;
      else event.deltaY = 1;
      this.okanMain.setZoomLevel(event);
    },
    makeToolTip(val) {
      if (val == null || this.okanMain.flatsData == null) return "";
      var value = this.okanMain.flatsData.find(x => x.id == val);
      if (value == undefined) return "";
      else {
        var accord = "";
        if(val > 1)
          accord = "s";
        return " pièce" + accord +" ( " + value.count + " )";
      }
    },
    goBack(){
      this.okanMain.showThree = false;
      this.okanMain.showAppartDetails = false;
      this.okanMain.leftMouseButtonDown = false;
      this.okanMain.selectedBatiment = null;
      this.okanMain.selectedAppart = null;
      this.okanMain.currentStair = null;
      this.selectedStair = null;
      this.okanMain.downGradeArianeLevel(0);      
    }
  }
};
</script>

<style src="./assets/css/main.css"></style>

